import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ship-ledger__note"
}
const _hoisted_2 = {
  key: 1,
  class: "ship-ledger__list"
}
const _hoisted_3 = {
  key: 0,
  class: "ship-ledger__label"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "ship-ledger__waybill is-plain"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = ["data-tour", "onClick"]
const _hoisted_8 = {
  key: 4,
  class: "ship-ledger__meta"
}
const _hoisted_9 = {
  key: 2,
  class: "ship-ledger__actions"
}
const _hoisted_10 = ["data-tour"]

import { computed } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  shipmentLedgerOf,
  type ShipmentLedgerItem,
  type ShipmentLedgerRow,
} from '@/utils/mallShipment'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallShipmentLedger',
  props: {
    item: {},
    size: { default: 'detail' },
    showReship: { type: Boolean, default: false },
    reshipTour: { default: '' },
    lookupTour: { default: '' }
  },
  emits: ["track", "reship"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const rows = computed(() => shipmentLedgerOf(props.item))
const hasReship = computed(() => rows.value.some((row) => row.kind === 'ADDITIONAL'))

function formatAt(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return `${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')} ${String(
    date.getHours(),
  ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

function metaOf(row: ShipmentLedgerRow) {
  /*
   * 배송 상태는 상단 배지로 크게 표시하므로 meta 줄에는 반복하지 않는다.
   * 개수(재발송) · 사유 메모 · 발송 시각 순으로만 붙인다.
   */
  const parts: string[] = []
  if (row.kind === 'ADDITIONAL' && row.qty) {
    parts.push(`${row.qty}개`)
  }
  if (row.memo) parts.push(row.memo)
  if (row.at) parts.push(formatAt(row.at))
  return parts.join(' · ')
}

function hasLiveStatus(row: ShipmentLedgerRow) {
  return Boolean(row.liveStatus)
}

function badgeClassOf(row: ShipmentLedgerRow) {
  if (row.delivered) return 'is-delivered'
  if (hasLiveStatus(row)) return 'is-inflight'
  return 'is-unknown'
}

function badgeIconOf(row: ShipmentLedgerRow) {
  if (row.delivered) return 'mdi-check-circle'
  if (hasLiveStatus(row)) return 'mdi-truck-fast-outline'
  return 'mdi-clock-outline'
}

function badgeLabelOf(row: ShipmentLedgerRow) {
  if (row.delivered) return '배송완료'
  if (hasLiveStatus(row)) return row.liveStatus
  return '조회 전'
}

return (_ctx: any,_cache: any) => {
  return (rows.value.length || __props.showReship || _ctx.$slots.actions)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ship-ledger", [
      `ship-ledger--${__props.size}`,
      hasReship.value ? 'is-split' : 'is-simple',
    ]])
      }, [
        (hasReship.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " 같은 주문입니다. 아래는 송장만 추가된 재발송입니다. "))
          : _createCommentVNode("", true),
        (rows.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: row.key,
                  class: _normalizeClass(["ship-ledger__row", [
          row.kind === 'ADDITIONAL' ? 'is-reship' : 'is-main',
          { 'is-delivered': row.delivered, 'is-inflight': hasLiveStatus(row) && !row.delivered },
        ]])
                }, [
                  (hasReship.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.label), 1))
                    : _createCommentVNode("", true),
                  (row.invoice)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "ship-ledger__waybill",
                        onClick: ($event: any) => (emit('track', row))
                      }, _toDisplayString([row.courier, row.invoice].filter(Boolean).join(' ')), 9, _hoisted_4))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.courier || '송장 없음'), 1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["ship-ledger__badge", badgeClassOf(row)]),
                    title: row.trackAt ? `택배사 최신: ${row.liveStatus}` : ''
                  }, [
                    _createVNode(AppIcon, {
                      icon: badgeIconOf(row),
                      size: 12
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(badgeLabelOf(row)), 1)
                  ], 10, _hoisted_6),
                  (row.invoice)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "ship-ledger__lookup",
                        "data-tour": __props.lookupTour || undefined,
                        onClick: ($event: any) => (emit('track', row))
                      }, " 배송조회 ", 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (metaOf(row))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(metaOf(row)), 1))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (__props.showReship || _ctx.$slots.actions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (__props.showReship)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "sui-btn sui-btn--sm ship-ledger__reship",
                    "data-tour": __props.reshipTour,
                    title: "오발송·누락으로 택배를 한 번 더 보냈을 때. 주문번호는 그대로입니다.",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('reship')))
                  }, " 재발송 ", 8, _hoisted_10))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "actions")
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})